/* global recalctotals,barracudaAmountKeyBasic,barracudaAmountKey,barracudaOutgoingKey,barracudaOutgoingKeyBasic,barracudaOutgoingKeyPro */
import domainStatus from '../components/domain_status';
import getAhsayUser from '../components/get_ahsay_user';

let resolveDomain = (val) => {
  domainStatus(val).then(result => {
    let records = [];

    for (let i = 0; i < result.data.result.length; i++) {
      records.push(result.data.result[i].exchange);
    }

    $('.host').find('input').val(records.join(' '));
    $('#btnCompleteProductConfig').removeAttr('disabled');
    $('#containerProductValidationErrors').addClass('hidden');
  }).catch(error => {
    $('#btnCompleteProductConfig').attr('disabled', true);
    let errors = $('#containerProductValidationErrors').removeClass('hidden').find('ul');
    errors.html('').append('<li><p>' + error.data.error + '</p></li>');
  });
};

let checkOutgoing = (initial = false) => {
  if (typeof barracudaAmountKey !== 'undefined' && typeof barracudaOutgoingKey !== 'undefined' && typeof barracudaAmountKeyBasic !== 'undefined' && typeof barracudaOutgoingKeyBasic !== 'undefined' && typeof barracudaOutgoingKeyPro !== 'undefined') {
    let amountKey = parseInt(barracudaAmountKey);
    let outgoingKey = parseInt(barracudaOutgoingKey);
    let amountBasicKey = parseInt(barracudaAmountKeyBasic);
    let outgoingBasicKey = parseInt(barracudaOutgoingKeyBasic);
    let outgoingProKey = parseInt(barracudaOutgoingKeyPro);
    let val = parseInt($('select[name="configoption[' + amountKey + ']"]').val());
    let outgoingVal = parseInt($('select[name="configoption[' + outgoingKey + ']"]').val());

    if (initial) {
      $('select[name="configoption[' + outgoingKey + ']"] option').each(function () {
        $(this).removeAttr('selected');
      });
    }

    let outgoingPro = $('select[name="configoption[' + outgoingKey + ']"] option[value="' + outgoingProKey + '"]');
    let outgoingBasic = $('select[name="configoption[' + outgoingKey + ']"] option[value="' + outgoingBasicKey + '"]');

    if (amountBasicKey === val) {
      outgoingPro.hide();
      outgoingBasic.show();

      if (outgoingVal === outgoingProKey) {
        $('select[name="configoption[' + outgoingKey + ']"]').val(outgoingBasicKey);
      }
    } else {
      outgoingPro.show();
      outgoingBasic.hide();

      if (outgoingVal === outgoingBasicKey) {
        $('select[name="configoption[' + outgoingKey + ']"]').val(outgoingProKey);
      }
    }

    recalctotals();
  }
};

let setOutgoing = () => {
  if (typeof barracudaAmountKey !== 'undefined') {
    let amountKey = barracudaAmountKey;

    $(document).on('change', 'select[name="configoption[' + amountKey + ']"]', function () {
      checkOutgoing();
    });
  }
};

let setPlaceholder = (input) => {
  let placeholder = 'uwnaam@' + input;
  $('.user-checker input').attr('placeholder', placeholder);
};

let checkDomain = () => {
  let field = $('.domain-checker');
  let typingTimer;
  let doneTypingInterval = 500;

  if (field.length) {
    let input = field.find('input');
    input.keyup(function () {
      clearTimeout(typingTimer);
      let val = input.val();
      let regex = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/;
      let match = val.match(regex);

      if (match) {
        setPlaceholder(val);
        typingTimer = setTimeout(function () {
          resolveDomain(val);
        }, doneTypingInterval);
      }
    });

    let val = input.val();
    if (val) {
      resolveDomain(val);
    }
  }
};

let resolveUser = (email, domain) => {
  let index = email.indexOf('@' + domain);

  if (index > 1) {
    $('#btnCompleteProductConfig').removeAttr('disabled');
    $('#containerProductValidationErrors').addClass('hidden');
  } else {
    $('#btnCompleteProductConfig').attr('disabled', true);
    let errors = $('#containerProductValidationErrors').removeClass('hidden').find('ul');
    errors.html('').append('<li><p>Het e-mailadres van de beheerder dient onderdeel van het ingevoerde domein te zijn.</p></li>');
  }
};

let resolveAhsayUser = (user) => {
  getAhsayUser(user).then(() => {
    $('#btnCompleteProductConfig').removeAttr('disabled');
    $('#containerProductValidationErrors').addClass('hidden');
  }).catch(error => {
    $('#btnCompleteProductConfig').attr('disabled', true);
    let errors = $('#containerProductValidationErrors').removeClass('hidden').find('ul');
    errors.html('').append('<li><p>' + error.data.error + '</p></li>');
  });
};

let checkUser = () => {
  let domain = $('.domain-checker');
  let field = $('.user-checker');
  let typingTimer;
  let doneTypingInterval = 500;

  if (field.length) {
    let input = field.find('input');
    let domainInput = domain.find('input');

    input.keyup(function () {
      clearTimeout(typingTimer);
      let val = input.val();
      if (val) {
        typingTimer = setTimeout(function () {
          resolveUser(val, domainInput.val());
        }, doneTypingInterval);
      }
    });

    let val = input.val();
    let host = domainInput.val();

    if (val && host) {
      resolveUser(val, host);
    }
  }
};

let checkAhsayUser = () => {
  let field = $('.ahsay-user-checker');
  let typingTimer;
  let doneTypingInterval = 500;

  if (field.length) {
    let input = field.find('input');

    input.keyup(function () {
      clearTimeout(typingTimer);
      let val = input.val();
      if (val) {
        typingTimer = setTimeout(function () {
          resolveAhsayUser(val);
        }, doneTypingInterval);
      }
    });

    let val = input.val();

    if (val) {
      resolveAhsayUser(val);
    }
  }
};

export default {
  init() {
    checkDomain();
    checkUser();
    checkAhsayUser();
    setOutgoing();
    checkOutgoing(true);
    setPlaceholder('uwdomein.nl');
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/configureproduct.js